var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.57177 12.0002C9.41954 12.0002 10.2483 11.7488 10.9532 11.2778C11.658 10.8068 12.2074 10.1373 12.5318 9.35409C12.8562 8.57084 12.9411 7.70898 12.7756 6.8775C12.6102 6.04603 12.2019 5.2823 11.6023 4.68288C11.0028 4.08347 10.239 3.67531 9.40752 3.51C8.57602 3.3447 7.71417 3.42969 6.93098 3.75422C6.14778 4.07875 5.47841 4.62825 5.00752 5.33322C4.53663 6.03819 4.28537 6.86696 4.28552 7.71474C4.28671 8.85109 4.73871 9.94054 5.5423 10.744C6.34589 11.5474 7.43542 11.9992 8.57177 12.0002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1788 15.5409C13.0926 14.4269 11.699 13.6619 10.176 13.3437C8.65303 13.0254 7.06973 13.1684 5.62839 13.7544C4.18705 14.3403 2.95309 15.3426 2.08414 16.6333C1.21519 17.9239 0.750703 19.4443 0.75 21.0002C0.75 21.1991 0.829018 21.3899 0.96967 21.5305C1.11032 21.6712 1.30109 21.7502 1.5 21.7502H15.645C15.8439 21.7502 16.0347 21.6712 16.1753 21.5305C16.316 21.3899 16.395 21.1991 16.395 21.0002C16.3979 20.2049 16.2751 19.4142 16.0312 18.6572C15.6681 17.4869 15.0333 16.4191 14.1788 15.5409Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.625 12.375C19.3854 12.375 20.8125 10.9479 20.8125 9.1875C20.8125 7.42709 19.3854 6 17.625 6C15.8646 6 14.4375 7.42709 14.4375 9.1875C14.4375 10.9479 15.8646 12.375 17.625 12.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.625 13.2524C16.6197 13.2562 15.6338 13.53 14.7705 14.0452C14.9333 14.1907 15.0975 14.3339 15.2513 14.4914C16.2725 15.5411 17.0311 16.8173 17.4653 18.2159C17.6139 18.6764 17.7236 19.1486 17.793 19.6274H22.5C22.6989 19.6274 22.8897 19.5484 23.0303 19.4078C23.171 19.2671 23.25 19.0764 23.25 18.8774C23.2484 17.3861 22.6553 15.9563 21.6007 14.9017C20.5462 13.8472 19.1164 13.254 17.625 13.2524Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleMobileIcon);
export default __webpack_public_path__ + "static/media/people-mobile-icon.a88a186fa993bb4e45e55d4bfeb6a72e.svg";
export { ForwardRef as ReactComponent };